import { useFilterCardSeriesContext } from "./filter-card-series.context";

export function FilterCardSeries() {
  const { tenantFilterElement, clearFiltersElement } =
    useFilterCardSeriesContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {tenantFilterElement}
      {clearFiltersElement}
    </div>
  );
}
